function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M16,0H4v12h12V0M2,14V4H0v12h12v-2H2ZM11.43,6l2.57,3-2,1-2-2.33-2,2.33-2-1,2.57-3-2.57-3,2-1,2,2.33,2-2.33,2,1-2.57,3Z"
      />
    </svg>
  );
}

export default Icon;
